<div class="container-box">
  <app-table-header
    (btnNewClick)="newButtonTrigger$.next()"
    (btnUpdateClick)="reloadTrigger$.next()"
    [showNewButton]="true"
    tableTitle="Gestione Usato"
  ></app-table-header>
  <div class="table-container">
    <app-new-table
      (btnDetailsClickEvent)="btnDetailsClickFunction($event)"
      [customButtons]="customButtons"
      [dataSource]="dataSource"
      [displayedColumns]="displayedColumns"
      [initialSort]="{
        active: 'created',
        direction: 'desc'
      }"
      [reloadTrigger$]="reloadTrigger$"
    ></app-new-table>
  </div>
</div>
